// extracted by mini-css-extract-plugin
module.exports = {"priceWithoutDiscounts":"PriceWithDiscount_priceWithoutDiscounts__2oS8S","pricesContainer":"PriceWithDiscount_pricesContainer__3SDKl"};